<template>
    <Modal ref="modalRef" width-class="max-w-4xl">
        <template #title>Ready to Drink Label Size Guide</template>

        <WysiwygContent>
            <p>
                We offer three labels that work great with a few of the most
                common beverage cans. In case you don’t have a ruler handy,
                we’ll use an average coffee mug as a size reference.
            </p>

            <div class="mt-6 flex flex-col gap-8 md:flex-row">
                <div class="flex-1">
                    <h4>3.25” x 7” Rectangular Label</h4>
                    <p class="text-sm font-bold">
                        (fits a Slim 7.5-8.5 oz. beverage can)
                    </p>
                    <p class="mt-1 text-sm">
                        Using your typical 4” x 5” coffee mug for comparison,
                        this label is slightly shorter and would cover about
                        three-fifths of its outer face of a standard size coffee
                        mug – like a parent using a child-sized blanket.
                    </p>

                    <h4 class="mt-4">3.625” x 8” Rectangular Label</h4>
                    <p class="text-sm font-bold">
                        (fits a Standard 11-12 oz. beverage can)
                    </p>
                    <p class="mt-1 text-sm">
                        Nearly as tall as a coffee mug and wrapping roughly
                        three-quarters of the way around it. Like a sumo
                        wrestler borrowing your comforter.
                    </p>

                    <h4 class="mt-4">5.25” x 7” Rectangular Label</h4>
                    <p class="text-sm font-bold">
                        (fits a Sleek 11-12 oz. beverage can)
                    </p>
                    <p class="mt-1 text-sm">
                        As wide as the Slim can label, but one-and-a-half times
                        taller. Switching to a denim-based metaphor, a coffee
                        mug would never get these jeans to button and the inseam
                        would be ten inches too long.
                    </p>
                </div>

                <div class="md:w-1/2">
                    <img
                        src="~/assets/images/beverage-labels/beverage-label-size-guide.svg"
                        alt="beverage label size guide"
                        class="mx-auto max-w-xs md:max-w-full"
                    />
                </div>
            </div>
        </WysiwygContent>
    </Modal>
</template>

<script setup lang="ts">
import Modal from '~/components/Modal.vue';

const modalRef = ref<InstanceType<typeof Modal> | null>(null);

const open = () => {
    modalRef.value?.open();
};

defineExpose({ open });
</script>
